module.exports = __webpack_public_path__ + "static/media/DSC_9715.8e05f766.jpg";